export const PERSISTED_STORAGE_NAMESPACE = 'stonkfinder';

export const ROLE_ADMIN = 'admin';

export const ROLE_BETA = 'beta';

export const ROLE_USER = 'user';
